export default "__VITE_ASSET__DtTzQctY__"